import React from 'react';
import ConfirmModal from '@components/modal/ConfirmModal';
import { AssessmentScoreResponse } from 'src/types/shared/Assessments';
import useDeleteAssessment from './hooks/useDeleteAssessment';

const DeleteAssessmentModal: React.FC<Props> = ({ score, hideModal }) => {
    const { isDeleting, deleteError, submitDelete } = useDeleteAssessment(
        score?.assessment?.id ?? -1,
        hideModal,
    );

    if (!score?.assessment?.id) {
        return null;
    }

    return (
        <ConfirmModal
            title="Delete Assessment"
            description={`Are you sure you want to delete the assessment submitted by '${score.assessor.email}'? This action cannot be reversed.`}
            closeModal={hideModal}
            error={deleteError}
            isPosting={isDeleting}
            handleSubmit={() => {
                submitDelete();
            }}
        />
    );
};

interface Props {
    score: AssessmentScoreResponse;
    hideModal: () => void;
}

export default DeleteAssessmentModal;
